import { render, staticRenderFns } from "./OzBadge.vue?vue&type=template&id=19134c1d&"
import script from "./OzBadge.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OzBadge.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports